import React from "react";
import NewPassword from "../auth/NewPassword";

export default function NewPasswordPage() {
  return <NewPassword />;
}
